module.exports = __webpack_public_path__ + "img/fj.b2a36a67.svg";